import app from 'flarum/forum/app';
import User from 'flarum/common/models/User';
import Tag from 'flarum/tags/common/models/Tag'
import Model from 'flarum/common/Model';
import SignupConfirmPage from './components/SignupConfirmPage';
import Application from 'flarum/common/Application';

import { extend, override } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';

function isRoute(routeName: string) {
	return app.current && app.current.data && (<any>app.current.data).routeName == routeName;
}

app.initializers.add('vspt/signup-custom-form', (app) => {
	User.prototype.subscribed_newsletter = Model.attribute('subscribed_newsletter');
	User.prototype.vspt_nonprofit_info_email = Model.attribute('vspt_nonprofit_info_email');
	User.prototype.vspt_partner_info_email = Model.attribute('vspt_partner_info_email');
	User.prototype.hasValidatedSignupForm = Model.attribute('hasValidatedSignupForm');
	
	Tag.prototype.expose_in_confirm_form = Model.attribute('expose_in_confirm_form');
	
	app.routes['vspt.signup-confirm'] = { path: '/confirm/:token', component: SignupConfirmPage };
	app.routes['vspt.signup-form'] = { path: '/signup-form', component: SignupConfirmPage };
});

extend(HeaderSecondary.prototype, 'items', function(items) {
	if(isRoute('vspt.signup-confirm') || isRoute('vspt.signup-form')) {
		items.remove('notifications');
		items.remove('search');
	} else {
		const user = app.session.user;
		if(user && user.exists && user.isEmailConfirmed() && !user.hasValidatedSignupForm()) {
			// This can happen when using an authentication method that does not require email confirmation (such as oauth)
			// In that case, the user does not see the signup form on the email validation page, so we redirect to another page with the same form
			m.route.set(app.routes['vspt.signup-form'].path);
			return;
		}
	}
});
